import { render, staticRenderFns } from "./Ip.vue?vue&type=template&id=315daa6c"
import script from "./Ip.vue?vue&type=script&lang=js"
export * from "./Ip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports